require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-push-play-to-see-our-progress-on-the-seren-row-site.json") })
        }
      }, "path---news-push-play-to-see-our-progress-on-the-seren-row-site");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-push-play-to-see-our-progress-on-the-seren-row-site!./.cache/json/news-push-play-to-see-our-progress-on-the-seren-row-site.json
// module id = 843
// module chunks = 231608221292675